
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg-inline--fa fa-construction fa-w-20",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","data-prefix":"far","data-icon":"construction","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M324 216a28 28 0 10-28-28 28 28 0 0028 28zm-18.62 140.36l-83-53.67-29.8 109.11a16 16 0 0011.22 19.64 15.8 15.8 0 004.2.56 16 16 0 0015.43-11.8l18.25-66.89L288 383.23V416a16 16 0 0032 0v-32.77a31.92 31.92 0 00-14.62-26.87zm135-9.26l-14 20.86L358.31 326l-10.53-52.75c-3.75-18.61-18.13-33.3-35.56-37.12l-24.59-7.3a48 48 0 00-48.78 18l-11.62 15.48a16 16 0 004.41 23.23l103.92 64 .09.07 70.67 43.48H385a19.13 19.13 0 00-18.21 12.51l-9.2 26.4h163.89l-54.32-84.64a16 16 0 00-26.75-.26zm190.67 80.78L367.37 25.3a57 57 0 00-94.71 0L8.89 427.89a52.87 52.87 0 00-2.31 54.88A56.23 56.23 0 0056.29 512h527.45a56.23 56.23 0 0049.71-29.27 52.82 52.82 0 00-2.37-54.85zm-39.84 32c-.66 1.24-2.72 4.08-7.5 4.08H56.29c-4.78 0-6.84-2.84-7.5-4.06a5.25 5.25 0 01.25-5.75l263.77-402.6a9.06 9.06 0 0114.41 0L591 454.19a5.27 5.27 0 01.24 5.73z"}})])
          )
        }
      }
    